import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { TemplateList } from "../../containers/MailTemplate/TemplateList";
import { TemplateAdd } from "../../containers/MailTemplate/TemplateAdd";

function Templates() {
  const { t } = useTranslation();
  const [visibleAddTemplate, setVisibleAddTemplate] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [templateId, setTemplateId] = useState(null);

  function toggleDialogAddTemplate() {
    setVisibleAddTemplate(!visibleAddTemplate);
  }
  return (
    <Fragment>
      {visibleAddTemplate ? (
        <TemplateAdd
          toggleDialog={toggleDialogAddTemplate}
          title={t("add_template")}
          setIsAdded={setIsAdded}
          templateId={templateId}
        ></TemplateAdd>
      ) : (
        ""
      )}
      <TemplateList
        toggleDialogAddTemplate={toggleDialogAddTemplate}
        isAdded={isAdded}
        setTemplateId={setTemplateId}
      ></TemplateList>
    </Fragment>
  );
}

export { Templates };
